// @ts-expect-error - Automatic, Please fix when editing this file
const selectNeedsProductType = (state, props) => props?.match?.params?.needsProductType ?? null;

export default selectNeedsProductType;
